import { FormState, getErrorText, useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { MultiInput } from '../../../MultiInput'
import type { MultiInputClientValidator } from '../../../MultiInput/validation'
import { EMAIL_REGEX } from '../constants'
import { messages } from './messages'

type EmailsInputProps = {
  name: string
  form: FormState
}

export function EmailsInput(props: EmailsInputProps) {
  const { name, form } = props
  const intl = useIntl()
  const { $t } = intl

  const values: string[] = useWatch({ form, name })

  const validateEmail: MultiInputClientValidator = (input: string) => {
    return input.length === 0 || EMAIL_REGEX.test(input.trim())
      ? { valid: true }
      : { valid: false, message: $t(messages.emailInvalid) }
  }

  const handleChange = (newValues: string[]) => {
    form.setValue(name, newValues)
    form.clearErrors(name)
  }

  return (
    <MultiInput
      name={name}
      label={$t(messages.emailLabel)}
      values={values}
      onChange={handleChange}
      inputValidation={validateEmail}
      helpText={$t(messages.emailHelp)}
      errorText={getErrorText(form, name)}
      maxEntries={10}
      debounce={500}
    />
  )
}
